import React from "react";
import { AccordionSet, Button } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
import { TitleNameFilterAccordion } from "../filters/TitleNameFilterAccordion";
export var FrequencyConflictFilters = function (_a) {
    var name = _a.name, hasUnappliedChanges = _a.hasUnappliedChanges, onNameChange = _a.onNameChange, onApplyFilters = _a.onApplyFilters;
    return (React.createElement("form", { onSubmit: function (e) {
            e.preventDefault();
            onApplyFilters();
        } },
        React.createElement(AccordionSet, null,
            React.createElement(TitleNameFilterAccordion, { id: "frequency-conflict-filter-name", value: name, onChange: onNameChange })),
        React.createElement(Button, { buttonStyle: "primary", marginBottom0: true, type: "submit", disabled: !hasUnappliedChanges },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.apply" }))));
};
